const QUESTION_FIELD_TYPE = 'CUSTOM_QUESTION';

const QUESTION_VALUE_TYPES = {
  YESNO: 'YES_NO',
  MULTIPLE: 'MULTIPLE',
  SHORT: 'SHORT',
};

export { QUESTION_FIELD_TYPE, QUESTION_VALUE_TYPES };
